<template>
<div>
    <div v-if="$gate.isAdmin() || $gate.isReception() || $gate.isAccount() || $gate.isManager() || $gate.isSupervisor()">
        <div id="pdf">
            <div class="row mb-2">
                <div class="col-md-4"></div>
                <div class="col-md-4 d-flex justify-content-center">
                    <img src="./../../Images/StepUp_logo.png" alt="StepUp" style="background-size: cover;width: auto; height: 150px;">
                </div>
                <div class="col-md-4"></div>
            </div>
            <div class="col-md-12 row">
                <div class="col-md-6">
                    <input type="date" v-model="filters.date" class="form-control" @input="endofday()">
                </div>
                <div class="col-md-6">
                    <select v-model="filters.user" class="form-control" @input="endofday()">
                        <option value="" disabled selected>All Staff</option>
                        <option v-for="user in users" :value="user.value" :key="user.value"> {{user.text}} </option>
                    </select>
                </div>
            </div>
            <div class="col-md-12">
                <div class="well">Transaction Reports </div>
                <table class="table table-bordered table-condensed">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Transaction Number</th>
                            <th>Customer</th>
                            <th>Payment Method</th>
                            <th>Item</th>
                            <th>Status</th>
                            <th>Taxable</th>
                            <th>Discount</th>
                            <th>VAT 5%</th>
                            <th>Total</th>
                            <th>Cashier</th>
                            <th>Notes</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="transaction in transactions" :key="transaction.id">
                            <td> {{transaction.date}} </td>
                            <td> STEP - {{transaction.id}} </td>
                            <th> {{transaction.customer}}</th>
                            <td> {{transaction.payment}} </td>
                            <td> {{transaction.quantity}} </td>
                            <td> {{transaction.status}} </td>
                            <td> {{transaction.taxable | formatAmount}} </td>
                            <td> {{transaction.discount | formatAmount}} </td>
                            <td> {{transaction.vat | formatAmount}} </td>
                            <td> {{transaction.total | formatAmount}} </td>
                            <td> {{transaction.cashier}} </td>
                            <td> {{transaction.notes}}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td> <strong> {{taxable | formatAmount}}  </strong></td>
                            <td> <strong> {{discount | formatAmount}}  </strong></td>
                            <td> <strong> {{vat | formatAmount}}  </strong></td>
                            <td> <strong> {{total | formatAmount}}  </strong></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div class="col-md-12" v-if="cancelled.length > 0">
                <div class="well">Cancelled Transaction Report</div>
                <table class="table table-bordered table-condensed">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Transaction Number</th>
                            <th>Customer</th>
                            <th>Payment Method</th>
                            <th>Item</th>
                            <th>Status</th>
                            <th>Taxable</th>
                            <th>Discount</th>
                            <th>VAT 5%</th>
                            <th>Total</th>
                            <th>Cashier</th>
                            <th>Notes</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="transaction in cancelled" :key="transaction.id">
                            <td> {{transaction.date}} </td>
                            <td> STEP - {{transaction.id}} </td>
                            <td> {{transaction.customer}}</td>
                            <td> {{transaction.payment}} </td>
                            <td> {{transaction.quantity }} </td>
                            <td> {{transaction.status}} </td>
                            <td> {{transaction.taxable | formatAmount}} </td>
                            <td> {{transaction.discount | formatAmount}} </td>
                            <td> {{transaction.vat | formatAmount}} </td>
                            <td> {{transaction.total | formatAmount}} </td>
                            <td> {{transaction.cashier}} </td>
                            <td> {{transaction.notes}} </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td> <strong> {{taxablecancelled | formatAmount}}  </strong></td>
                            <td> <strong> {{discountcancelled | formatAmount}}  </strong></td>
                            <td> <strong> {{vatcancelled | formatAmount}}  </strong></td>
                            <td> <strong> {{totalcancelled | formatAmount}}  </strong></td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            <div class="col-md-12" v-if="refunded.length > 0">
                <div class="well">Refunded Transaction Report</div>
                <table class="table table-bordered table-condensed">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Transaction Number</th>
                            <th>Customer</th>
                            <th>Payment Method</th>
                            <th>Item</th>
                            <th>Status</th>
                            <th>Taxable</th>
                            <th>Discount</th>
                            <th>VAT 5%</th>
                            <th>Total</th>
                            <th>Cashier</th>
                            <th>Notes</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="transaction in refunded" :key="transaction.id">
                            <td> {{transaction.date}} </td>
                            <td> STEP - {{transaction.id}} </td>
                            <td> {{transaction.customer}}</td>
                            <td> {{transaction.payment}} </td>
                            <td> {{transaction.quantity}} </td>
                            <td> {{transaction.status}} </td>
                            <td> {{transaction.taxable | formatAmount}} </td>
                            <td> {{transaction.discount | formatAmount}} </td>
                            <td> {{transaction.vat | formatAmount}} </td>
                            <td> {{transaction.total | formatAmount}} </td>
                            <td> {{transaction.cashier}} </td>
                            <td> {{transaction.notes}}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td> <strong> {{parseFloat(taxablerefunded).toFixed(2)}} AED </strong></td>
                            <td> <strong> {{parseFloat(discountrefunded).toFixed(2)}} AED </strong></td>
                            <td> <strong> {{parseFloat(vatrefunded).toFixed(2)}} AED </strong></td>
                            <td> <strong> {{parseFloat(totalrefunded).toFixed(2)}} AED </strong></td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            <div class="col-md-12">
                <div class="well">Product Report</div>
                <table class="table table-bordered table-condensed">
                    <thead>
                        <tr>
                            <th>Product Name</th>
                            <th>Size/Color</th>
                            <th>Quantity</th>
                            <th>Taxable</th>
                            <th>Discount</th>
                            <th>VAT 5%</th>
                            <th>Total</th>
                            <th>Notes</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(product,index) in products" :key="index">
                            <td> {{product.productname}} </td>
                            <td> {{product.optionname}} </td>
                            <td> {{product.quantity}} </td>
                            <td> {{product.Taxable}} </td>
                            <td> {{product.discount}} </td>
                            <td> {{product.VAT}} </td>
                            <td> {{product.price}} </td>
                            <td> {{product.notes}} </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td> <strong> {{productTaxable | formatAmount}}  </strong></td>
                            <td> <strong> {{productDiscount | formatAmount}}  </strong></td>
                            <td> <strong> {{productVat | formatAmount}}  </strong></td>
                            <td> <strong> {{productTotal | formatAmount}}  </strong></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div class="col-md-12">
                <div class="well">Payment Report</div>
                <table class="table table-bordered table-responsive">
                    <thead>
                        <tr>
                            <th>Payment Method</th>
                            <th>Payment Total</th>
                        </tr>
                    </thead>
                    <tbody>
                            <tr v-if="payments.cash && payments.cash !== '0.00'">
                                <td>Cash </td>
                                <td> {{payments.cash | formatAmount}} </td>
                            </tr>
                            <tr v-if="payments.card  && payments.card !== '0.00'">
                                <td>Card </td>
                                <td> {{payments.card | formatAmount}} </td>
                            </tr>
                            <tr v-if="payments.credit && payments.credit !== '0.00'">
                                <td>Credit </td>
                                <td> {{payments.credit | formatAmount}} </td>
                            </tr>
                            <tr v-if="payments.bank && payments.bank !== '0.00'">
                                <td>Bank </td>
                                <td> {{payments.bank | formatAmount}} </td>
                            </tr>
                            <tr v-if="payments.cheque && payments.cheque !== '0.00'">
                                <td>Cheque </td>
                                <td> {{payments.cheque | formatAmount}} </td>
                            </tr>
                            <tr v-if="payments.telr && payments.telr !== '0.00'">
                                <td>Telr </td>
                                <td> {{payments.telr | formatAmount}} </td>
                            </tr>
                            <tr v-if="payments.magnati && payments.magnati !== '0.00'">
                                <td>Magnati </td>
                                <td> {{payments.magnati | formatAmount}} </td>
                            </tr>
                        <tr>
                            <td>Cash Drawer</td>
                            <td> {{drawers | formatAmount}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="col-md-12" id="print">
                <button class="btn btn-success hidden-print"  @click="print"><i class="fa fa-print"></i></button>
                <button class="btn btn-success hidden-print" @click="pdf"><i class="fa fa-file"></i></button>
                <excel
                        class = "btn btn-info"
                        :data  = "transactions"
                        type  = "xls"
                        name = "End_of_Day_Report.xls">
                        Download Excel
                </excel>

        </div>
    </div>
        <div v-else>
            <notfound></notfound>
        </div>
</div>
</template>

<script>
import html2pdf from 'html2pdf.js'
import JsonExcel from 'vue-json-excel';
export default {
    components: {
        excel: JsonExcel
    },
    data(){
        return {
            transactions:[],
            products:[],
            payments:[],
            cancelled: [],
            refunded: [],
            users:[],
            drawers: '',
            filters: {
                date: this.$root.myDate,
                draw: 0,
                user: '',
                user_id: this.$root.id,
                name: this.$root.staffname,
            },
            hide: false


        }
    },
    created(){
        this.endofday();
    },
    methods: {
        endofday(url = './api/Report/endofday') {
            let self = this;
            this.filters.draw++
            axios
            .get(url, {params:this.filters})
            .then((result) => {
                      this.transactions = result.data.transactions
                      this.products = result.data.products
                      this.payments = result.data.payments
                      this.drawers = result.data.drawer
                      this.users = result.data.users
                      this.cancelled = result.data.cancel
                      this.refunded = result.data.refund


            }).catch((err) => {
                console.log(err)
            });
        },
        print(){
            var printButton = document.getElementById("print")
            printButton.style.visibility = 'hidden'
            // var divPrint = this.$refs.print

            // window.document.write(divPrint.innerHTML)
            window.print()
            
            // Use afterprint event to restore button visibility after print dialog closes
            window.onafterprint = () => {
                printButton.style.visibility = 'visible'
                window.onafterprint = null
            }
        },
        pdf() {
            var elements = document.getElementById('pdf')

            var opt = {
            margin: 15,
            filename: 'End of Day Report.pdf',
            image: {type: 'jpeg', quality: 0.98},
            html2canvas: {scale: 1},
            jsPDF: {
              unit: 'mm',
            //   format: [280, 350],
              orientation: 'landscape'
            }
          }
          html2pdf().set(opt).from(elements).save()
        }
    },
    computed: {
        taxable() {
            return this.transactions.reduce((total, item) => {
                return total + Number(item.taxable)
            }, 0)
        },
        discount() {
            return this.transactions.reduce((total, item) => {
                return total + Number(item.discount)
            }, 0)
        },
        vat() {
            return this.transactions.reduce((total, item) => {
                return total + Number(item.vat)
            }, 0)
        },
        total() {
            return this.transactions.reduce((total, item) => {
                return total + Number(item.total)
            }, 0)
        },
        productTaxable(){
            return this.products.reduce((total, item) => {
                return total + Number(item.Taxable)
            }, 0)
        },
        productDiscount() {
            return this.products.reduce((total, item) => {
                return total + Number(item.discount)
            }, 0)
        },
        productVat() {
            return this.products.reduce((total, item) => {
                return total + Number(item.VAT)
            }, 0)
        },
        productTotal() {
            return this.products.reduce((total, item) => {
                return total + Number(item.price)
            }, 0)
        },

        taxablecancelled() {
            return this.cancelled.reduce((total, item) => {
                return total + Number(item.taxable)
            }, 0)
        },
        discountcancelled() {
            return this.cancelled.reduce((total, item) => {
                return total + Number(item.discount)
            }, 0)
        },
        vatcancelled() {
            return this.cancelled.reduce((total, item) => {
                return total + Number(item.vat)
            }, 0)
        },
        totalcancelled() {
            return this.cancelled.reduce((total, item) => {
                return total + Number(item.total)
            }, 0)
        },

        taxablerefunded() {
            return this.refunded.reduce((total, item) => {
                return total + Number(item.taxable)
            }, 0)
        },
        discountrefunded() {
            return this.refunded.reduce((total, item) => {
                return total + Number(item.discount)
            }, 0)
        },
        vatrefunded() {
            return this.refunded.reduce((total, item) => {
                return total + Number(item.vat)
            }, 0)
        },
        totalrefunded() {
            return this.refunded.reduce((total, item) => {
                return total + Number(item.total)
            }, 0)
        }
    },
    filters:{
        formatAmount: function (value) {
            return parseFloat(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/Report/EndDay/endOfDay.vue